import React from 'react'
import { Box, Typography } from '@mui/material'
import { pointText } from '../../lib/rule'
import WinLoseRule from './WinLoseRule'
import PlayerWrong from './elements/PlayerWrong'

const BoardRule = ({ simple, rule }) => {
  const pt = pointText(simple)

  const rights = rule.right.num === 1 ? '1着' : `${rule.right.num}着まで`

  const point = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {pt}
      </Box>
    </>
  )

  const correct = label => {
    return (
      <Box component="span" className="rule-element">
        <Box component="span" className="rule-title">
          {label}
        </Box>
        <Box component="span" className="rule-content">
          {point(rule.board.pointCorrect)}
        </Box>
      </Box>
    )
  }

  const firstCorrect = () => (
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">
        {rights}正解
      </Box>
      <Box component="span" className="rule-content">
        {point(rule.board.pointCorrect + rule.player.pointCorrect)}
      </Box>
    </Box>
  )

  const withoutFirst = () => (
    <>
      {correct('正解')}
    </>
  )

  const withFirst = () => (
    <>
      {firstCorrect()}
      {correct('その他正解')}
      <PlayerWrong simple={simple} rule={rule.player}
                   label={`${rights}誤答`} />
    </>
  )

  const board = () => (
    <Box className="board">
      <Typography variant="body2" className="rule-line">
        {!rule.board.applyNormal ? withoutFirst() : withFirst()}
      </Typography>
    </Box>
  )

  return (
    <Box className="board-rule">
      <Typography variant="caption">
        <Box component="span" className="rule-caption">ボードスコア</Box>
      </Typography>
      <Box className="content">
        {board()}
        <WinLoseRule simple={simple} rule={rule.player} />
      </Box>
    </Box>
  )
}

export default BoardRule
